import { Component, OnInit, Inject, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIConstants } from '../../../../_config/restapis';
import { APITelemarketerHeaderRegistration } from '../../_services/telemarketer-header-registration/API-telemarketer-header-registration';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalSuccessComponent } from '../../../../_helpers/Modals/success/modal.success';
import { ErrModalData, PromptModalData, SuccModalData, ModalData } from '../../../../_helpers/Modals/ModalData';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { APIHeaderService } from '../../_services/header/API-header';
import { formatDate } from '@angular/common';
import { BadWordsApiService } from 'src/app/_root/Trai_module/_services/bad-words/bad-words-api.service';
import { Router } from '@angular/router';

const today = new Date();
const ranvalue = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

export interface DialogData {
	animal: string;
	name: string;
}

export interface headerTypeValues{
	key:string
	value:string
}

export interface communicationModeValues{
	key:string
	value:string
}

export interface PrincipalEntityName{
	key:string
	value:string
}

@Component({
  selector: 'app-header-voice',
  templateUrl: './header-voice.component.html',
  styleUrls: ['./header-voice.component.css']
})
export class HeaderVoiceComponent implements OnInit {

	// Added code for variable declaration
	public myModelProperty: Array<any>;
	header_name: string;
	public telemarkerRTMNo: string;
	public categoryfromresponse: any;
	ranvaluee = ranvalue;
	selectedServiceprovider: string;
	selectedheadertype: string;
	selectedCircle: string;
	selectedCategory: string;
	selectedHeader: string;
	public categoryres: any;
	setHeadertelemarketer: any;
	public category: any;
	setCircle: any;
	setheadertype: any;
	headername: any;
	categorybox1: any;
	categorybox2: any;
	date: any;
checkingHeader:any;
	headerType1:headerTypeValues[]=[
		{key:'P',value:'Promotional'},
		{key:'T',value:'Transaction'},
		{key:'SE',value:'Service-Explicit'},
		{key:'SI',value:'Service-Implicit'},
		
	]

	cMode1:communicationModeValues[]=[
		{key:'11',value:'Voice Call'},
		{key:'13',value:'Auto Dialer Call (With Pre-recorded Announcement)'},
		{key:'14',value:'Auto Dialer Call (With Connectivity to live agent)'},
		{key:'15',value:'Robo-Calls'},
	]



	PrincipalEntity:PrincipalEntityName[]=[
		{key:'JE0100001',value:'HSBC'},
		{key:'JE0100002',value:'TJSB'},
		{key:'JE0100003',value:'ICICI'},
		{key:'JE0100004',value:'Axis'},
	]

	rootHeaderVal: any;
	principalEntityId: any;
	entityRefNo: any;
	orgName: any;
	cliName:any;
	data:any;
	allPrincipalEntity: any;



	  //modeOfCommunicationData:  any []  =  [ 'Voice Call',  'SMS',  'Auto Dailer Call with Pre-recorded',  'Auto Dailer Call with Live Agent',  'Robo-calls'];
	  public categoryy = [ { name: "Banking / Insurance / Financial products / credit cards",value : 1 },
	  { name: "Real Estate",value : 2 },
	  { name: "Education",value : 3 },
	  { name: "Health",value : 4 },
	  { name: "Consumer Goods and Automobiles",value : 5 },
	  { name: "Communication / Broadcasting / Entertainment / IT",value : 6 },
	  { name: "Tourism and Leisure",value : 7 },
	  { name: "Food and Beverages",value : 8 },
	  
	  ] 


	public entityName: any;
	headerTypeJson: any;
	PrincipalEntityJson:any;
	communicationModeJson:any;
	


	constructor(private http: HttpClient,
		private _call: APITelemarketerHeaderRegistration,
		private $modal: $ModalManagerService,
		private modal: BsModalService,
		private db: $DBManagerService,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private hs: APIHeaderService,
		private bw:BadWordsApiService,
		private router: Router,

	) {

		this.selectedServiceprovider;
		this.selectedCircle;
		this.selectedCategory;
		

	}
	headerRegForm: FormGroup;
	submitted: boolean = false;
	selectedValue: String;
	Entity_EMP_ID: string = "";
	public Entity_ID = '';
	newHeader: string = "";
	errMsgRoot: string = "";
	//	deSelect: boolean = false;
	entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);

	ngOnInit() {

		this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		this.entityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
		this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
		this.orgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
		this.getAllPrincipalEntity();
		

		this.headerRegForm = this.fb.group({
			cName:['',[Validators.required]],
			headerType:['',[Validators.required]],
			cMode:['',[Validators.required]],
			// PrincipalEntity:['',],
			newH:['',[Validators.pattern("[1-9][0-9]{9}")]],
			
			category: ['',]
		});



		// if (this.selectedValue == "TM"){
		// console.log("selectedValue",this.selectedValue)
		// this.headerRegForm.controls["PrincipalEntity"].enable();
		// this.headerRegForm.controls['PrincipalEntity'].setValidators([Validators.required]);
		// console.log("hii");
		//  this.headerRegForm.controls["PrincipalEntity"].updateValueAndValidity();
		// }



	}

	//To Fetch al the PrincipalEntity
	
	getAllPrincipalEntity(){
		
		   this.hs.getAllPrincipalEntity()
			.subscribe(r => {
				
				console.log("response ____ : ",r.data);
				this.allPrincipalEntity = r.data;

			})
		
	}
	
	onChangeCategory(category){
		console.log("category :",category);
		  this.category = category;
	   }


	get f() { return this.headerRegForm.controls; }

	onSubmit() {
		
		this.submitted = true;
                

		if (this.headerRegForm.invalid) {
			console.log("invalid form", this.headerRegForm);
			return;
		}
		else {
		
			this.bw.checkBadWord(this.headerRegForm.get('newH').value)

        .subscribe(r=>{
				console.log("response for the restricted words ",r.Data.isValid)

            if(r.Data.isValid== 'Invalid')

            {

                this.$modal.errorModal({

                    title: 'Restricted Header',

                    msg: 'Please use a different Header name'

                });

            }

            else

            {

                console.log(this.headerRegForm);

								this.APIcreateHeader();
								this.headerRegForm.reset();
								this.headerRegForm .clearValidators();
								this.headerRegForm .updateValueAndValidity();
								

            }

            

        });
		}
	}




	// Added code for service provider slection
	serviceproviderFilter(selectedServiceprovider: string) {
		//console.log('value is ', selectedServiceprovider);
		this.setHeadertelemarketer = selectedServiceprovider;
		console.log("this.setHeadertelemarketer" + this.setHeadertelemarketer);

	}
	// Added code for circle slection
	circleFilter(selectedCircle: string) {
		//console.log('value is ', selectedCircle);
		this.setCircle = selectedCircle;
		console.log("this.setCircle " + this.setCircle);
	}

	headertypeFilter(selectedheadertype: string) {
		console.log('header Typevalue is ', selectedheadertype);
		this.setheadertype = selectedheadertype;
		console.log("this.setheadertype " + this.setheadertype);
	}

	// Added code for categories slection
	categoryFilter(selectedCategory: string) {

		let toArray = selectedCategory.split(":");
		console.log("toArray :", toArray[0]);
		selectedCategory = toArray[0];
		this.selectedCategory = selectedCategory;
		this.myModelProperty.push(selectedCategory);
		console.log("this.myModelProperty" + this.myModelProperty);
	}

	// Added code for creating header name
	headerName(selectedHeader: string) {
		console.log('telemarketer value is ', this.setHeadertelemarketer);
		console.log('circle value is ', this.setCircle);
		//console.log('category value is ', this.selectedCategory);
		console.log('setheadertype value is ', this.setheadertype);
		if (this.setHeadertelemarketer && this.setCircle && this.setheadertype) {
			this.headername = this.setHeadertelemarketer + this.setCircle + this.setheadertype + '-';
			console.log("headername first:" + this.headername);
		}

	}

	//Added code to get & send data to nodejs 
	addHeader(categorybox2) {
		//this.categorybox1 = categorybox1;
		this.categorybox2 = categorybox2;
		//console.log("categorybox1", this.categorybox1);
		console.log("categorybox2", this.categorybox2);
		console.log("this.header_name", this.header_name);
		this.header_name = this.headername + this.categorybox2;
		console.log("headername 2", this.header_name);
		this.APIcreateHeader();

	}


	APIgetCategory(): void {
		this._call.getcategory()
			.subscribe(r => this.categoryres = r);
			this.categoryres = this.categoryy; 

	}


		APIcreateHeader() {
			let mobileNo = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);
			this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
			this.entityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
			const today = new Date();
			const ranvalue = today.getTime();
			let headerId = ranvalue;
			this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_ID, headerId);
			//let entityNamee = this.headerRegForm.get("entityName").value;
			let cli = this.headerRegForm.get("newH").value;
			let cname = this.headerRegForm.get("cName").value;
			
			this.telemarkerRTMNo = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
			// let supportingDocuments = this.headerRegForm.get("supDocs").value;
			// const file1: any = document.getElementById('supporting_documents');
			// console.log("file :", file1.files[0]);
			this.headerTypeJson=this.headerRegForm.get('headerType').value
			this.communicationModeJson=this.headerRegForm.get('cMode').value;
		//	this.PrincipalEntityJson=this.headerRegForm.get('PrincipalEntity').value
			const headerRegForm: FormData = new FormData();
			this.selectedValue = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
			let E_Org_Name=this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
			let principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);


			console.log("this.selectedValue : ",this.selectedValue);
	
			if (this.selectedValue == "TM") {
				console.log("in ");
				
				this.data = {
				
					"peid": principalEntityId,
					"cname":cname,
					"cli":cli,
					"htyp":this.headerTypeJson,
					"cmode":this.communicationModeJson,
					"ctgr":this.category,
					"tmid":	principalEntityId	 	
			}
			}
			else {
			
	
			this.data = {
				
				
					"peid": principalEntityId,
					
					"cname":cname,
					"cmode":this.communicationModeJson,
					"htyp":this.headerTypeJson,
					
					"cli":cli,
					
					"ctgr":this.category,
					"tmid":principalEntityId
					
	
				
			}
				 }
	
	
			console.log("data displaying :" + JSON.stringify(this.data));
			this.hs.RegisterHeaderVoice(this.data).subscribe(r => {
				//console.log("Posting Subcategories 2" + r.error.name);
				console.log("------------r.status-----------------",r.status);
console.log("------------this is r-------------------",r)
				
				if (r.status == false) {
					this.$modal.errorModal({
						title: 'Header Registration',
						msg: r.message
					});
				
				}
				
				else if(r.status ==true) {
					console.log("-----------r ka message hai",r.message);
					this.$modal.successModal({
						title: 'Header Registration',
						msg: r.message
					});
					this.router.navigateByUrl('/header-voice-summary');
				}
				else 
				{
					this.$modal.errorModal({
						title: 'Header Registration',
						msg: "Please try again, Some error Occured"
					});
				}
			})
	
		}

}
